window.onload = function() {
  let theModal = document.querySelector('.product-media-modal');
  let modalCloser = document.querySelector('.product-media-modal__dialog');

  console.log('DB TEST // SCRIPT LOADED');

  if (modalCloser) {
    modalCloser.addEventListener("mouseup", function() {
      console.log('DB TEST // Close Button Pushed!');
      hideTheModal();
    }, false);
  } else {
    console.log('DB TEST // var does not exist: ModalClose-{{ section.id }}');
  }


  let imgButts = document.querySelectorAll('.product__media-item.grid__item.slider__slide');

  console.log('DB TEST // How Many Butts? ' + imgButts.length + ' Butts.');

  for (var i = 0; i < imgButts.length; i++) {
    imgButts[i].addEventListener("mouseup", function() {
      showTheModal();
    }, false);
  };

  function showTheModal() {
    theModal.style.visibility = "visible";
    theModal.style.opacity = 90;
    theModal.style.zIndex = 999;
  }

  function hideTheModal() {
    theModal.style.visibility = "hidden";
    theModal.style.opacity = 0;
    theModal.style.zIndex = -1;
  }
}